import { useEffect, useMemo, useRef, useState } from "react"
import selectOnFocus from '../../../../../../modules/autoselect'
import { EXIST_PATH } from '../../../../../../modules/API/settings'
import styled from "styled-components"
import PackageIcon from "../../../../../../generic/icons/IconLib/PackageBoxIcon"
import ScalesIcon from "../../../../../../generic/icons/IconLib/ScaleIcon"
import ShekelIcon from "../../../../../../generic/icons/IconLib/ShekelIcon"
import { roundToTwo } from "../../../../../../modules/roundToTwo"
import { convertStringDateToUnix } from "../../../../../../generic/utils/forDate/convertStringDateToUnix"
import { diffDates } from "../../../../../../generic/utils/forDate/diffDates"
import { checkPackType } from "../../../../../../generic/utils/checkPackType"
import { handleNotifications } from "../../../../../../generic/utils/handleNotifications"
import { useDetectOutsideClick } from "../../../../../../generic/hooks/useDetectOutsideClick"
import ProductCard from './ProductCard'
import ProductImage from '../../../queries/TeudotDetails/Components/ProductImage'
import { useAvailablePacksWithDefault } from '../hooks/useAvailablePacksWithDefault'



export const ItemMainWrapper = styled.div`
    width: 320px;
    min-height: 120px;
    position: relative;
    outline: none;
    /* background: #fdfdfd; */
    display: flex;
    flex-flow: row-reverse;
    /* align-items: center; */
    border-radius: 10px;
    /* overflow: hidden; */
    gap: 0.5em;
    /* filter: drop-shadow(4px 3px 3px rgba(41,127,118,0.41)); */
    
`
export const ImageContainer = styled.div`
    height: 6em;
    width: 6em;
    position: relative;
    border-radius: 50% 50% 25% 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fdfdfd;
    margin-top: 0.7em;
    cursor: pointer;
    -webkit-box-shadow: 2px 8px 2px -6px rgba(41,127,118,0.71); 
    box-shadow: 2px 8px 2px -6px rgba(41,127,118,0.71);
    &::after {
        position: absolute;
        left: -1em;
        top: 18%;
        content: '';
        width: 3em;
        height: 4em;
        background: #fdfdfd;
        z-index: -1;
        -webkit-box-shadow: 2px 8px 2px -6px rgba(41,127,118,0.71); 
        box-shadow: 2px 8px 2px -6px rgba(41,127,118,0.71);
    }
`
export const ImageBlock = styled.div`
    height: 5em;
    width: 5em;
   
    border-radius: 50%;
    background-color: #fdfdfd;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid #fdfdfd;
`
export const ContentWrapper = styled.div`
    position: relative;
    width: 70%;
    min-height: 100%;
    overflow: hidden;
    border-radius: 10px;
    /* background: red; */
    
`
export const FrontWrapper = styled.div`
    position: absolute;
    min-height: 100%;
    width: 100%;
    top: 0;
    display: flex;
    flex-flow: column;
    border-radius: 10px;
    justify-content: flex-start;
    align-items: center;
    gap: 0.2em;
    background: #fdfdfd;
    padding: 0.5em;
    -webkit-box-shadow: 2px 8px 2px -6px rgba(41,127,118,0.71); 
    box-shadow: 2px 8px 2px -6px rgba(41,127,118,0.71);
`

export const TitleFrontWrapper = styled.div`
    width: 100%;
    min-height: 2.5em;
    background: rgba(76,148,141, 0.7);
    color: #fdfdfd;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    /* -webkit-box-shadow: 2px 8px 2px -6px rgba(41,127,118,0.71); 
    box-shadow: 2px 8px 2px -6px rgba(41,127,118,0.71); */
`
export const ControlitemWrapper = styled.div`
    width: 100%;
    height: 100%;
    /* padding: 0.2em; */
    /* background: #eff3f4; */
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 0.7em;
    
`
export const CountContainer = styled.div`
    position: relative;
    min-height: 3.5em;
    min-width: 3.5em;
    background: #eff3f4;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-box-shadow: 2px 7px 7px -6px rgba(41,127,118,0.71); 
    box-shadow: 2px 7px 7px -6px rgba(41,127,118,0.71);
`
export const CountInput = styled.input`
    width: 3em;
    height: 3em;
    background: #fdfdfd;
    border-radius: 50%;
    border: none;
    outline: none;
    padding: 0 0.5em;
    color: #4b938c;
    text-align: center;
    &:disabled {
        opacity: 0.5;
    }
    
`
export const Amlaca = styled.div`
    position: absolute;
    background: #fdfdfd;
    color: tomato;
    height: 2.2em;
    min-width: 5.5em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 0 20px 20px;
    border: none;
    right: 0;
    bottom: 0em;
    z-index: 2;
    cursor: pointer;
    /* -webkit-box-shadow: -0px 3px 10px -3px rgba(41,127,118,0.71); 
    box-shadow: -0px 3px 10px -3px rgba(41,127,118,0.71); */
    @media screen and (max-width: 450px){
        height: 2.4em;
        width: 2.4em;
    }    
`

export const CountButton = styled.button`
    position: absolute;
    background: #fdfdfd;
    color: #4b938c;
    height: 2.2em;
    width: 2.2em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: none;
    right: -0.5em;
    bottom: -0.2em;
    cursor: pointer;
    -webkit-box-shadow: -0px 3px 10px -3px rgba(41,127,118,0.71); 
    box-shadow: -0px 3px 10px -3px rgba(41,127,118,0.71);
    @media screen and (max-width: 450px){
        height: 2.4em;
        width: 2.4em;
    }    
`
export const CountButtonMinus = styled.button`
    position: absolute;
    background: #fdfdfd;
    color: #4b938c;
    height: 2.2em;
    width: 2.2em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: none;
    
    left: -0.5em;
    bottom: -0.2em;
    cursor: pointer;
    -webkit-box-shadow: -0px 3px 10px -3px rgba(41,127,118,0.71); 
    box-shadow: -0px 3px 10px -3px rgba(41,127,118,0.71);
    @media screen and (max-width: 450px){
        height: 2.4em;
        width: 2.4em;
    }
`
export const BackWrapper = styled(FrontWrapper)`
    transition: 0.5s;
    background: #e9f0f0;
    height: 100%;
`
export const BackDataWrapper = styled.div`
    width: 100%;
    min-height: 50%;
    border-radius: 30px;
    background: #eff3f4;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5em;
    padding: 0 0.4em;
`
export const BackItemWrapper = styled.label`
    position: relative;
    height: 80%;
    max-width: 100%;
    border-radius: 30px;
    background: #fdfdfd;
    overflow: hidden;
`
export const BackItemInput = styled.input`
    width: 100%;
    height: 100%;
    border: none;
    text-align: right;
    padding: 0 1em;
    font-size: 1em;
    outline: none;
    z-index: 0;
    color: #4b938c;
`
export const TextField = styled.textarea`
    width: 100%;
    height: 100%;
    appearance: none;
    border: none;
    overflow: auto;
    outline: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    resize: none;
    padding: 0.5em 1em;
    direction: rtl;
    color: #4b938c;
    font-size: 1.05em;
    border-radius: 30px;
    background: #fdfdfd;
    &::-webkit-scrollbar {
        width: 0;
    }
    &::placeholder {
        font-size: 0.9em;
        font-family: Arial, Helvetica, sans-serif;
    }
    
`
export const IconWrapper = styled.div`
    position: absolute;
    /* background: red; */
    height: 100%;
    width: 2.5em;
    color: #4b938c;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    top: 0;
    font-size: 0.9em;
    z-index: 1;
    cursor: pointer;
`



export default function GoodsItem({ id, desc, Packs, pack_id, Price, getMlai, getMhir,
    goodsListDefault, setProduct, product, chengeAkpaca, packegeList, item, ProductCalculationMethod,
    PackID, RecID, ProductDesc, VarietyDesc, ProductID, VarietyID, SizeID, ImageUrl, GeneralProductID = 0, GroupID, OrderPacks, SalePrice, OrderWeight,
    presetWindow, filterClose, collectDataProduct, GroupArray, filterGoodsValue, ExistingStock, dateForAmlaca, RecommendQty,
    setOrderTotal, orderTotal, AvailablePacks, isEditPrice, getLastPrice,
     getGoodPrice, isPriced, PackWeight, isLoadPrice, Pack_Name, MinPrice, OriginalPrice
}) {
    const [packs, setPacks] = useState(OrderPacks || Packs || +'0');
    const [remark, setRemark] = useState('');
    const packRef = useRef(PackID)
    const [isOpenLastPriceOverlay, setIsOpenLastPriceOverlay] = useState(false)
    const [lastPrice, setLastPrice] = useState(null)
    const overlayPriceRef = useRef(null)
    useEffect(() => {
        const convert = () => {
            let converted = remark.split('\n').join(' ')
            // console.log(converted)
            setRemark(converted)
        }
        convert()
    }, [remark])

    const [packType, setPackType] = useState(PackID || '')
    const [priceGood, setPriceGood] = useState(Price && MinPrice !== undefined ? Math.max(MinPrice, Price).toFixed(2) : 0)
    const [mlai, setMlai] = useState(ExistingStock || +'0')
    const [side, setSide] = useState(false)

    const showPrice = useMemo(() => {
        return priceGood || Price?.toFixed(2)
    }, [Price, priceGood])

    const isGetPriceAllow = useMemo(() => {
        console.log(Price)
        return !isPriced 
    }, [isPriced])
    if(AvailablePacks.some(e => e.PackWeight !== 0)) {
        // console.group('--------------------------------')
        // console.log(ProductDesc.trim(), VarietyDesc.trim(), SizeID)
        // console.log(AvailablePacks)
        // console.log(PackID)
        // console.log(checkPackType(packegeList, PackID))
        // console.groupEnd()
    }
    const weightCalc = useMemo(() => {
        let weight = 0
        const packTypeDef = checkPackType(packegeList, PackID)
        const tempPackWeight = AvailablePacks.filter(e => e.PackID === PackID)[0]?.PackWeight
        const packIcon = packTypeDef === '2' ? <PackageIcon /> : 
            packTypeDef === '1' ? <ScalesIcon /> :
            ProductCalculationMethod === 1 ? <PackageIcon /> : <ScalesIcon />
        if (
            (!packType || 
            packType === '0') ||
            !(packTypeDef === '1' || packTypeDef === '2') 
        ) {
            weight = packs * (tempPackWeight || PackWeight)
        } else {
            weight = packs 
        }
        return {weight, packIcon: packIcon, packTypeDef}
    }, [
            packType,
            packs,
            PackWeight,
            PackID, packegeList,
            AvailablePacks,
            ProductCalculationMethod
        ]
    )

    const availablePacksWithDefault = useAvailablePacksWithDefault(AvailablePacks, PackID, Pack_Name)

    const handleOpenLastPriceOverlay = () => {
        setIsOpenLastPriceOverlay(!isOpenLastPriceOverlay)
    }
    // console.log(MinPrice, Price)
    const calculatePrice = (e) => {
        const value = Number(e.target.value)
        if (MinPrice !== undefined && value < Math.min(MinPrice, OriginalPrice)) {
            console.log(MinPrice, OriginalPrice)
            console.log(value)
            setPriceGood(value)
            handleNotifications(`המחיר נמוך מהמינימום (${Math.min(MinPrice, OriginalPrice)})`, {type: "warning"})
        } else {
            setPriceGood(value)
        }
    }
    const handleMlaiChange = (e) => {
        const value = Number(e.target.value)
        if (value < 0) {
            setMlai(0)
        } else {
            setMlai(value)
        }
    }
    const groupId = GroupArray.filter(item => item === +filterGoodsValue)

    const plusValue = () => {
        setPacks(packs + 1)
        setOrderTotal(orderTotal += 1)
    }

    const minusValue = (e) => {
        if (packs > 0) {
            setPacks(packs - 1)
            setOrderTotal(orderTotal -= 1)
        }
    }

    //switch good side
    const toggleSide = () => {
        setSide(!side)
        
    }
    const handleGetLastPrice = async (e) => {
        e.stopPropagation()
        try {
            const reqDat = {
                ProductID: ProductID,
                VarietyID: VarietyID,
                Size: (SizeID ?? '').toString().trim(),
                QualityID: 0,
                PackID: PackID,
            }
            const res = await getLastPrice(reqDat)
            if (res) {
                console.log('[handleGetLastPrice] reqDat:', reqDat, 'res:', res)

                setLastPrice(res)
                setIsOpenLastPriceOverlay(true)
            }
        } catch (err) {
            console.error('[handleGetLastPrice] failed:', err)
        }
    }

    const getPrice = () => {
        console.log(isGetPriceAllow)
        if(isGetPriceAllow) {
            console.log('getPrice')
            getGoodPrice(ProductID, VarietyID, SizeID, PackID, id, item)
        }
    }
    const dateDiff = diffDates(convertStringDateToUnix(dateForAmlaca.choosen), convertStringDateToUnix(dateForAmlaca.toDay))
    let bacPic = ImageUrl === '' ? 'url("/emptyBox.png") center center no-repeat' : `url("${EXIST_PATH}${ImageUrl}") center center no-repeat`
    // let displayToggle = side ? 'translateY(100%)' : 'translateY(0)';
    let displayToggleBack = !side ? 'translateY(100%)' : 'translateY(0)';
    let counterToggle = packs > 0 || Packs > 0 ? 'block' : 'none'
    // let checkPrice = priceGood === 0 ? 'מחיר' : priceGood

    const isMlaiHidden = !getMlai
    const isMhirHidden = !(getMhir || isEditPrice)

    let setlectedPack = product.filter(e => e.id === id)[0]?.PackID
    const prodName = `${ProductDesc?.trim()} ${VarietyDesc?.trim()}`;
    const finalPrice = showPrice < Math.min(MinPrice, OriginalPrice) ? OriginalPrice : showPrice
    useDetectOutsideClick(overlayPriceRef, () => setIsOpenLastPriceOverlay(false))

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        collectDataProduct(
            product, setProduct, RecID, id, VarietyID,
            packs, packType, ProductID, SizeID, remark,
            mlai, finalPrice, groupId[0], Price, SalePrice,
            prodName, ImageUrl
        )
    }, [packs, packType, priceGood, mlai, remark])
    /* eslint-enable react-hooks/exhaustive-deps */

    const handlePriceBlur = () => {
        if (showPrice < Math.min(MinPrice, OriginalPrice)) {
            setPriceGood(OriginalPrice || 0)
        }
    }

    const recommendCount =
        dateDiff === 0 && RecommendQty?.AvgCnt1 > 0 ? Math.round(RecommendQty.AvgCnt1) :
        dateDiff === 1 && RecommendQty?.AvgCnt2 > 0 ? Math.round(RecommendQty.AvgCnt2) :
        dateDiff === 2 && RecommendQty?.AvgCnt3 > 0 ? Math.round(RecommendQty.AvgCnt3) : null;

    // Weight/units recommendation (AvgWgt) — shown only for unit/kg pack types,
    // independent of recommendCount (may render even when the count badge is absent).
    const recommendWeight =
        !(weightCalc.packTypeDef === '1' || weightCalc.packTypeDef === '2') ? null :
        dateDiff === 0 && RecommendQty?.AvgWgt1 > 0 ? Math.round(RecommendQty.AvgWgt1) :
        dateDiff === 1 && RecommendQty?.AvgWgt2 > 0 ? Math.round(RecommendQty.AvgWgt2) :
        dateDiff === 2 && RecommendQty?.AvgWgt3 > 0 ? Math.round(RecommendQty.AvgWgt3) : null;

    const handleStepperPlus = (e) => { e?.stopPropagation?.(); plusValue(); };
    const handleStepperMinus = (e) => { e?.stopPropagation?.(); minusValue(e); };
    const handleStepperInput = (e) => { setPacks(+e.target.value); };
    /* MoreButton stops propagation (panel toggle is its own concern). */
    const handleMoreClick = (e) => { e?.stopPropagation?.(); toggleSide(); };
    /* Media click keeps bubbling so the card-level onClick (getPrice) still fires
       — matches the legacy behaviour where tapping the image fetched the price. */
    const handleMediaClick = () => { toggleSide(); };

    return (
        <ProductCard
            id="good-item-select"
            onClick={getPrice}
            tabIndex={0}
            title="for more information - tap on the image"
        >
            <ProductCard.MoreButton onClick={handleMoreClick} />
            {recommendCount !== null ? <ProductCard.HintBadge value={recommendCount} /> : null}

            <ProductCard.Media onClick={handleMediaClick}>
                <ProductImage id={GeneralProductID} />
            </ProductCard.Media>

            <ProductCard.TitleBlock
                title={`${ProductDesc?.trim()} ${VarietyDesc?.trim()} ${SizeID?.trim()}`}
                hint={
                    <>
                        <ProductCard.QtyBadge value={weightCalc.weight} icon={weightCalc.packIcon} active={packs > 0} />
                        {recommendWeight != null ? <ProductCard.HintInlineBadge value={recommendWeight} /> : null}
                    </>
                }
            />

            <ProductCard.PackSelect
                defaultValue={setlectedPack || PackID || 0}
                disabled={packRef.current !== 0}
                dir="rtl"
                onChange={(e) => setPackType(e.target.value)}
                onClick={(e) => e.stopPropagation()}
            >
                <option value={0}>ארגז/קרטון</option>
                {availablePacksWithDefault.map((p) => (
                    <option key={p.PackID} value={p.PackID}>{p.Pack_Name?.trim()}</option>
                ))}
            </ProductCard.PackSelect>

            <ProductCard.Stepper
                value={packs}
                disabled={isLoadPrice}
                accent={packs > 0}
                onPlus={handleStepperPlus}
                onMinus={handleStepperMinus}
                onInputChange={handleStepperInput}
            />

            <ProductCard.Panel open={side} onClose={handleMoreClick}>
                <ProductCard.FieldGrid>
                    <ProductCard.Field
                        // label="מחיר"
                        type="number"
                        inputMode="decimal"
                        step="any"
                        min={0}
                        readOnly={!isEditPrice}
                        placeholder="מחיר"
                        value={showPrice}
                        onChange={calculatePrice}
                        onBlur={handlePriceBlur}
                        onFocus={selectOnFocus}
                        onClick={(e) => { e.stopPropagation(); selectOnFocus(e); }}
                        hidden={isMhirHidden}
                        actionIcon={<ShekelIcon />}
                        onAction={handleGetLastPrice}
                    />
                    <ProductCard.Field
                        // label="מלאי"
                        type="number"
                        inputMode="numeric"
                        placeholder="0"
                        value={roundToTwo(mlai)}
                        onChange={handleMlaiChange}
                        onFocus={selectOnFocus}
                        onClick={(e) => { e.stopPropagation(); selectOnFocus(e); }}
                        hidden={isMlaiHidden}
                    />
                </ProductCard.FieldGrid>
                <ProductCard.Textarea
                    // label="הערה למוצר"
                    placeholder="הוסיפו הערה…"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    maxLength={100}
                />
            </ProductCard.Panel>

            <LastPriceOverlay ref={overlayPriceRef} $isOpen={isOpenLastPriceOverlay}>
                <LastPriceCard>
                    <LastPriceClose
                        type="button"
                        onClick={(e) => { e.stopPropagation(); setIsOpenLastPriceOverlay(false); }}
                        aria-label="close"
                    >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                            <path d="M18 6 6 18M6 6l12 12" />
                        </svg>
                    </LastPriceClose>
                    <LastPriceLabel>מחיר אחרון</LastPriceLabel>
                    {lastPrice && (
                        <LastPriceValue>
                            <ShekelIcon />
                            <span>{lastPrice.Price}</span>
                        </LastPriceValue>
                    )}
                </LastPriceCard>
            </LastPriceOverlay>
        </ProductCard>
    );
}

const LastPriceOverlay = styled.div`
    position: absolute;
    inset: 0;
    z-index: 7;
    display: grid;
    place-items: center;
    padding: 14px;
    border-radius: 18px;
    background: ${({ theme }) =>
        `linear-gradient(180deg, ${theme.colors.surface}E6, ${theme.colors.surface}F2)`};
    backdrop-filter: blur(14px) saturate(160%);
    -webkit-backdrop-filter: blur(14px) saturate(160%);
    pointer-events: ${props => (props.$isOpen ? 'auto' : 'none')};
    opacity: ${props => (props.$isOpen ? 1 : 0)};
    transform: ${props => (props.$isOpen ? 'scale(1)' : 'scale(0.96)')};
    transition:
        opacity 220ms cubic-bezier(0.2, 0.8, 0.2, 1),
        transform 220ms cubic-bezier(0.2, 0.8, 0.2, 1);
`

const LastPriceCard = styled.div`
    position: relative;
    width: 100%;
    max-width: 220px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 18px 16px 16px;
    background: ${({ theme }) => theme.colors.surface};
    border: 1px solid ${({ theme }) => theme.colors.line};
    border-radius: 14px;
    box-shadow:
        0 1px 2px rgba(0, 0, 0, 0.04),
        0 12px 28px -16px rgba(0, 0, 0, 0.18);
`

const LastPriceClose = styled.button`
    position: absolute;
    top: 6px;
    inset-inline-end: 6px;
    width: 24px;
    height: 24px;
    border: 0;
    background: transparent;
    color: ${({ theme }) => theme.colors.ink3};
    cursor: pointer;
    border-radius: 6px;
    display: grid;
    place-items: center;
    transition:
        background ${({ theme }) => theme.motion.fast},
        color ${({ theme }) => theme.motion.fast};

    svg { width: 14px; height: 14px; }

    &:hover {
        background: ${({ theme }) => theme.colors.line2};
        color: ${({ theme }) => theme.colors.ink};
    }
`

const LastPriceLabel = styled.span`
    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.02em;
    color: ${({ theme }) => theme.colors.ink3};
    text-transform: none;
`

const LastPriceValue = styled.div`
    display: inline-flex;
    align-items: baseline;
    gap: 6px;
    font-family: ${({ theme }) => theme.fonts.mono};
    font-size: 22px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.ink};

    svg {
        color: ${({ theme }) => theme.colors.accentDeep};
        width: 16px;
        height: 16px;
    }
`
